import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../utils/token";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AddScholarPackages({ serviceId }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [serviceList, setServiceList] = useState([]);
  const [serviceName, setServiceName] = useState(null);
  const [subServiceList, setSubSurviceList] = useState([]);
  const [subserviceName, setSubserviceName] = useState(null);

  const [testTypeList, setTestTypeList] = useState([]);
  const [testTypeName, setTestTypeName] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [subServicePrograms, setSubServicePrograms] = useState(null);
  const [programList, setProgramList] = useState(null);
  const [selectedClassList, setSelectedClassList] = useState([
    { id: 1, name: "Class 9", value: "class_9" },
    { id: 2, name: "Class 10", value: "class_10" },
    { id: 3, name: "Class 11", value: "class_11" },
    { id: 4, name: "Class 12", value: "class_12" },
  ]);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState(null);
  const [partnerUnivercity, setPartnerUniverCity] = useState(null);
  const [nonpartnerUnivercity, setNonPartnerUniverCity] = useState(null);
  const [isloading, setIsLoading] = useState(true);
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState(null);
  const [countryList, setCountryList] =useState([]);
  const [countryName, setCountryName] =useState(null);
  const [currency,setcurrency] =useState(null);
  const [installmentsCount, setInstallmentsCount] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    setError,
    reset,
    resetField
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const fileeredServis = data.filter(
            (i) => i.service_name !== "Undefined"
          );
          const selectedService = data.find((i) => i.id === serviceId);
          setServiceList(fileeredServis);
          setServiceName(selectedService);
          setValue("service_id", selectedService?.id || null);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlechangeService = (e, value) => {
    setSubserviceName(null);

    setSubServicePrograms(null);
    setClassName(null);
    setServiceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);
    setTestTypeName(null);
    setValue("service_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const filteredServices = data.filter(
            (i) => i.service_id === serviceName?.id
          );

          setSubSurviceList(filteredServices);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [serviceName]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}subservice-program`)
      .then((response) => response.json())
      .then((data) => {
        const filterddata = data.filter(
          (i) => subserviceName?.id === i.sub_service_id
        );
        setProgramList(filterddata);
      })
      .catch((error) => {
        console.error("Error fetching sub service programs:", error);
      });
  }, [subserviceName]);

  const handlechangeprogram = (e, value) => {
    setClassName(null);
    setSubServicePrograms(value);
    setValue("scholars_program_id", value?.id);
    setValue("scholars_class", null)
  };

  const handlechangeSubservice = (e, value) => {
    setSubServicePrograms(null);
    setClassName(null);

    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);

    const subserviceIds = value?.id;

    setSubserviceName(value);

    setValue("sub_service_id", subserviceIds);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}advisordashboard/gettesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypeList(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();
          const filteredTestType = data.filter(
            (i) => i.test_type_id === testTypeName?.id
          );
          setSubtestTypeList(filteredTestType);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [testTypeName]);


  useEffect(() => {
      // Fetch menu items using the fetch function
      fetch(`${API_ENDPOINT}country`)
        .then((response) => response.json())
        .then((data) => {
          const filteredcountry=data.filter((i)=>i.country_name==="India" || i.country_name==="Nepal" )
          setCountryList(filteredcountry);
       
        })
        .catch((error) => {
          console.error("Error fetching testtypes:", error);
        });
    }, []);
  
    const handleCountryChange=(e,value)=>{
      setBranchName([])
      setValue("branch_id",[])
           setCountryName(value);
  
        setValue("country_id", value?.id);
        setcurrency(value?.currency_code)
        setValue("currency", value?.currency_code);
    }
  

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}branch`)
      .then((response) => response.json())
      .then((data) => {
        const flteredBranch=data.filter((i)=>i.country_id===countryName?.id)
        setBranchList(flteredBranch);
    
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, [countryName]);

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];
  const handlebranchChange = (e, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      const selectedBranch = branchList.map((i) => i.id);
      setBranchName(branchList);
      setValue("branch_id", selectedBranch);
    } else {
      setBranchName(value);
      setValue(
        "branch_id",
        value.map((i) => i.id)
      );
    }
  };

  useEffect(() => {
    if (subServicePrograms?.name === "Accelerated SUAP (for 11-12 class)") {
      const filteredClass = selectedClassList.filter(
        (i) => !["class_9", "class_10"].includes(i.value)
      );
      setClassList(filteredClass);
    } else {
      setClassList(selectedClassList);
    }
  }, [subServicePrograms]);

  const handleChangeClass = (e, value) => {
    setClassName(value);
    setValue("scholars_class", value?.value);
  };

  const onSubmit = async (data) => {
    console.log("Form Submitted:", data);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        ...data,
        user_id: parseInt(userId),
        duration: parseInt(data.duration),
        original_price: parseInt(data.original_price),
        discounted_price: parseInt(data.discounted_price),
        non_partner_university: parseInt(data.non_partner_university),
        partner_university: parseInt(data.partner_university),
      };
      const response = await fetch(`${API_ENDPOINT}package`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (response.ok) {
        showSnackbar("Packages Added Successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      }else if (response.status === 409) {
        showSnackbar("Duplicate Package Name", "error");
      }
       else {
        showSnackbar(result.error, "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };

  const handleInstallmentsChange = (value, fieldOnChange) => {
  fieldOnChange(value);

  const prevCount = installmentsCount || 0;

  // Reset previous installment fields to null
  for (let i = 1; i <= prevCount; i++) {
    setValue(`installment_${i}_amount`, null, { shouldValidate: true, shouldDirty: true });
    setValue(`installment_${i}_description`, null, { shouldValidate: true, shouldDirty: true });
  }

  // Update the current count
  setInstallmentsCount(value === 1 ? 0 : value);
};


  return (
    <>
      {isloading ? (
        <Typography variant="h4">Loading...</Typography>
      ) : (
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.service_id)}>
              <Typography variant="h6">
                Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="service_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    disableClearable
                    size="small"
                    value={serviceName}
                    onChange={handlechangeService}
                    options={serviceList}
                    getOptionLabel={(option) => option.service_name}
                    tooltipContent={(option) => option.service_name}
                    error={Boolean(errors.service_id)}
                    helperText={
                      errors.service_id && errors?.service_id?.message
                    }
                    readOnly
                  />
                )}
              />
            </FormControl>
          </Grid>
          {serviceName !== null && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.sub_service_id)}>
                <Typography variant="h6">
                  Sub Service{" "}
                  <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
                </Typography>
                <Controller
                  name="sub_service_id"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      disableClearable
                      value={subserviceName}
                      onChange={handlechangeSubservice}
                      options={subServiceList}
                      getOptionLabel={(option) => option.name}
                      error={Boolean(errors.sub_service_id)}
                      helperText={
                        errors.sub_service_id && errors?.sub_service_id?.message
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          {subserviceName !== null && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl
                fullWidth
                error={Boolean(errors.premium_admission_programs_id)}
              >
                <Typography variant="h6">Admission Program</Typography>
                <Controller
                  name="premium_admission_programs_id"
                  control={control}
                  // rules={{ required: true }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      value={subServicePrograms}
                      onChange={handlechangeprogram}
                      options={programList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          {[
            "Advanced SUAP (for 8th class onwards)",
            "Accelerated SUAP (for 11-12 class)",
          ].includes(subServicePrograms?.name) && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="h6">Class </Typography>
                <Controller
                  name="class_id"
                  control={control}
                  // rules={{ required: true }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      value={className}
                      onChange={handleChangeClass}
                      options={classList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h6">
                Number Of Partner Universities{" "}
              </Typography>
              <Controller
                name="partner_university"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                     type="number"
                    value={partnerUnivercity}
                    onChange={(e) => {
                      setPartnerUniverCity(e.target.value);
                      setValue("partner_university", e.target.value);
                    }}
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h6">
                Number Of Non Partner Universities{" "}
              </Typography>
              <Controller
                name="non_partner_university"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    value={nonpartnerUnivercity}
                    onChange={(e) => {
                      setNonPartnerUniverCity(e.target.value);
                      setValue("non_partner_university", e.target.value);
                    }}
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.package_name)}>
              <Typography variant="h6">
                Package Name{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="package_name"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.package_name)}
                    helperText={
                      errors.package_name && errors?.package_name?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

            <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.country_id)}>
              <Typography variant="h6">Country </Typography>
              <Controller
                name="country_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                 disableClearable
                    value={countryName}
                    onChange={handleCountryChange}
                    options={countryList}
                    getOptionLabel={(option) => option.country_name}
                    tooltipContent={(option) => option.country_name}
                     error={Boolean(errors.country_id)}
                    helperText={
                      errors.country_id && errors?.country_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

{countryName && (
  <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.branch_id)}>
              <Typography variant="h6">currency</Typography>
              <Controller
                name="currency"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    multiple
                    value={currency}
                    InputProps={{readOnly:true , style:{borderRadius:'10px'}}}
               error={Boolean(errors.currency)}
                    helperText={
                      errors.currency && errors?.currency?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
)}

{countryName && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.branch_id)}>
              <Typography variant="h6">Branch</Typography>
              <Controller
                name="branch_id"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    multiple
                    value={branchName}
                    onChange={handlebranchChange}
                    options={allBranchList}
                    getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                  />
                )}
              />
            </FormControl>
          </Grid>
           )}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.original_price)}>
              <Typography variant="h6">
                Original Price{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="original_price"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    type="number"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.original_price)}
                    helperText={
                      errors.original_price && errors?.original_price?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.discounted_price)}>
              <Typography variant="h6">Discounted Price </Typography>
              <Controller
                name="discounted_price"
                control={control}
                // rules={{ required: true }}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    type="number"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
        <FormControl fullWidth error={Boolean(errors.payable_installment)}>
          <Typography variant="h6">
            Payable Installments <span style={{ color: "red" }}>*</span>
          </Typography>
          <Controller
            name="payable_installment"
            control={control}
            rules={{ required: "This is a required field" }}
            render={({ field }) => (
              <Select
                {...field}
                size="normal"
                style={{ borderRadius: "10px" }}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  handleInstallmentsChange(value, field.onChange);
                }}
              >
                <MenuItem value={1}>No installments</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
              </Select>
            )}
          />
          {errors.payable_installment && (
            <FormHelperText>{errors.payable_installment.message}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      {/* Dynamic Installment Fields */}
      {Array.from({ length: installmentsCount }, (_, index) => (
        <Grid item container spacing={2} key={index}>
          {/* Installment Amount */}
          <Grid item xs={12} md={6}>
            <FormControl
              fullWidth
              error={Boolean(errors[`installment_${index + 1}_amount`])}
            >
              <Typography variant="h6">
                {`Installment ${index + 1} Amount`}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name={`installment_${index + 1}_amount`} // ✅ flat naming
                control={control}
                rules={{ required: "This is a required field" }}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    type="number"
                    fullWidth
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors[`installment_${index + 1}_amount`])}
                    helperText={
                      errors[`installment_${index + 1}_amount`]?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          {/* Installment Description */}
          <Grid item xs={12} md={6}>
            <FormControl
              fullWidth
              error={Boolean(errors[`installment_${index + 1}_description`])}
            >
              <Typography variant="h6">
                {`Installment ${index + 1} Description`}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name={`installment_${index + 1}_description`} // ✅ flat naming
                control={control}
                rules={{ required: "This is a required field" }}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(
                      errors[`installment_${index + 1}_description`]
                    )}
                    helperText={
                      errors[`installment_${index + 1}_description`]?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      ))}

           <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={Boolean(errors.description)}>
                    <Typography variant="h6">
                      Package Description{" "}
                    </Typography>
                    <Controller
                      name="description"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          multiline
                          rows={6}
                          size="normal"
                          InputProps={{
                            style: {
                              borderRadius: "10px",
                            },
                          }}
                          error={Boolean(errors.description)}
                          helperText={errors.description && errors?.description?.message}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

          <Grid item xs={12} textAlign="end">
            <Button
              variant="contained"
              size="medium"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
